document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.collapsible-row--toggle');
  if (!toggle) return;

  const currentRow = toggle.closest('.product-form--block');
  if (!currentRow) return;

  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

  setTimeout(() => {
    const nowExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (nowExpanded) {
      const siblings = currentRow.parentElement.querySelectorAll('.product-form--block');

      siblings.forEach(block => {
        if (block === currentRow) return;

        const siblingToggle = block.querySelector('.collapsible-row--toggle');
        const siblingWrapper = block.querySelector('.collapsible-row--wrapper');

        if (siblingToggle && siblingWrapper) {
          siblingToggle.setAttribute('aria-expanded', 'false');
          siblingWrapper.style.height = '0px';
          siblingWrapper.setAttribute('data-transition-active', 'false');
        }
      });
    }
  }, 50);
});

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.testimonial-slider');

  sliders.forEach((slider) => {
    if (slider.classList.contains('flickity-enabled')) return;

    new Flickity(slider, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true
    });
  });
});